// @ts-expect-error
import VideoLayout from '../../../modules/UI/videolayout/VideoLayout';
import { OPEN_CHAT } from './actionTypes';
import { closeChat } from './actions.any';
import { closeAttachments, closeDatisalute } from "../pm-utils/actions";
export * from './actions.any';
/**
 * Displays the chat panel.
 *
 * @param {Object} participant - The recipient for the private chat.
 * @param {Object} _disablePolls - Used on native.
 * @returns {{
 *     participant: Participant,
 *     type: OPEN_CHAT
 * }}
 */
export function openChat(participant, _disablePolls) {
    return function (dispatch) {
        dispatch({
            participant,
            type: OPEN_CHAT
        });
        dispatch(closeDatisalute(participant));
        dispatch(closeAttachments(participant));
    };
}
/**
 * Toggles display of the chat panel.
 *
 * @returns {Function}
 */
export function toggleChat() {
    return (dispatch, getState) => {
        const isOpen = getState()['features/chat'].isOpen;
        if (isOpen) {
            dispatch(closeChat());
        }
        else {
            dispatch(openChat());
        }
        // Recompute the large video size whenever we toggle the chat, as it takes chat state into account.
        VideoLayout.onResize();
    };
}
